'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _neptune = require('./neptune');

var _neptune2 = _interopRequireDefault(_neptune);

var _n2 = require('./_n');

var _n3 = _interopRequireDefault(_n2);

var _uson = require('../../node_modules/uson');

var _uson2 = _interopRequireDefault(_uson);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_neptune2.default.manifest = {

	init: function init(p) {

		p = p || document;

		_n3.default.qsa('[neptune-manifest]', p).forEach(function (el) {

			el.manifest = _uson2.default.parse(el.getAttribute('neptune-manifest'))[0];

			// if (!!el.manifest.observe)
			// 	Neptune.manifest.observe(el)

			setTimeout(function () {
				_neptune2.default.manifest.process(el);
			}, el.manifest.delay || 0);
		});
	},

	process: function process(el) {

		if (!!el.manifest.map) {
			el.manifest.data = el.manifest.data || {};
			for (var prop in el.manifest.map) {
				var target = _n3.default.qs(el.manifest.map[prop].source, el) || el;
				el.manifest.data[prop] = _neptune2.default.manifest.extract(target);
			}
		}

		_n3.default.array(el.manifest.then).forEach(function (_then) {
			if (!!_then['liquid:load'] && !!_neptune2.default.liquid) {
				_neptune2.default.liquid.load(_then['liquid:load'].topic, el.manifest.data);
			}
		});
	},

	extract: function extract(element, isSVG) {
		var getAttributes = function getAttributes(attributes, format) {
			if (format == 'object') {
				var atts = {};
				Array.from(attributes).forEach(function (attribute) {
					atts[attribute.name] = attribute.value;
				});
				return atts;
			}
			return Array.prototype.map.call(attributes, function (attribute) {
				return {
					att: attribute.name,
					value: attribute.value
				};
			});
		};
		return Array.prototype.map.call(element.childNodes, function (node) {
			var details = {
				content: node.childNodes && node.childNodes.length > 0 ? null : node.textContent,
				// atts: node.nodeType !== 1 ? [] : getAttributes(node.attributes, 'array'),
				atts: node.nodeType !== 1 ? [] : getAttributes(node.attributes, 'object'),
				type: node.nodeType === 3 ? 'text' : node.nodeType === 8 ? 'comment' : node.tagName.toLowerCase(),
				data: node.dataset,
				node: node
			};
			details.isSVG = isSVG || details.type === 'svg';
			details.children = _neptune2.default.manifest.extract(node, details.isSVG);
			return details;
		});
	},

	observe: function observe(el) {

		// // Options for the observer (which mutations to observe)
		// const config = el.manifest.observe || { attributes: true, childList: true, subtree: true };

		// // Callback function to execute when mutations are observed
		// const callback = function(mutationsList, observer) {
		//    // Use traditional 'for loops' for IE 11
		//    for(let mutation of mutationsList) {
		//        if (mutation.type === 'childList') {
		//            console.log('A child node has been added or removed.');
		//        }
		//        else if (mutation.type === 'attributes') {
		//            console.log('The ' + mutation.attributeName + ' attribute was modified.');
		//        }
		//        Neptune.manifest.process(el)
		//    }
		// 	if(!!el.manifest.observe.once)
		// 		el.manifestObserver.disconnect();
		// };

		// // Create an observer instance linked to the callback function
		// el.manifestObserver = new MutationObserver(callback);

		// // Start observing the target node for configured mutations
		// el.manifestObserver.observe(el, el.manifest.observe);

		// if(!!el.manifest.observe.now)
		// 	el.manifestObserver.disconnect();

	}

};

window.Neptune = _neptune2.default;

exports.default = _neptune2.default.manifest;